import api from '../../../core/api/client';

export const roleService = {
  async getPermissionsCatalog() {
    try {
      const response = await api.get('/roles/permissions');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async getRoles() {
    try {
      const response = await api.get('/roles');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async updateRolePermissions(roleId, permissions) {
    try {
      const response = await api.put(`/roles/${roleId}/permissions`, permissions);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};
